import React, {useContext} from 'react';
import {useSelector} from "react-redux";
import {useParams, useSearchParams} from 'react-router-dom';

import SimpleTable from "../../components/Common/Elements";

import {Card, CardContent, Grid, Stack, Typography,} from "@mui/material";


import Loading from "../../components/Common/Loading";
import {useGetStateV2RTQuery} from "../../core/api/rogerthat-state-api";
import {paymentUserStatus} from "../../core/utils/constants";
import TechInfoRT from "../TechInfo/techInfoRT";
import {format} from "date-fns";
import {isEmpty} from "../../core/utils/StringUtils";
import {SnackBarContext} from "../../snackBarProvider";
import {Alert} from "@mui/material";
import UserSocialInfoRT from "../UserInfo/userSocialInfoRT";
import {useGetStateV2MCQuery} from "../../core/api/mc-state-api";
import {stringify} from "lossless-json";
import TechInfoMC from "../TechInfo/techInfoMC";
import UserSocialInfoMC from "../UserInfo/userSocialInfoMC";
import SpammerControl from "../BanControl/SpammerControl"
import StateCopyLogCard from "../../components/Common/StateCopyLogCard"


function DashboardMC() {

    const {deviceId: deviceIdParam} = useParams();
    const [searchParams] = useSearchParams();
    const deviceId = deviceIdParam ?? "";
    const stateId = searchParams.get('vendorId') ?? "";
    const deviceIdIsEmpty = !deviceId && !stateId;

    const {
        data: obj,
        isLoading,
        isFetching,
        isSuccess,
        isError,
        error
    } = useGetStateV2MCQuery({deviceId, stateId}, {skip: deviceIdIsEmpty})


    const getByName = (items = [], name) => items.find((item) => item.Name === name)?.Amount

    let panel1 = ""

    const useSnackBars = () => useContext(SnackBarContext);
    const {addAlert} = useSnackBars();

    const getItemByType = (profile, type) => {
        return profile.filter(item => item.__type === type)[0]
    }

    if (typeof obj === "object" && obj.hasOwnProperty('data')) {
debugger
        const data = JSON.parse(obj.data)

        if((data.hasOwnProperty('userID') || data.hasOwnProperty('UserID'))) {
            let source = {
                account_info: [],
                progress_info: [],
                payment_info: [],
                ingame_goods: [],
                lc_profile: []
            }


            const battlePass = getItemByType(data.Records.LCProfile._profiles,'LoadableBattlepassProfile')

            try {
                source = {
                    account_info: [
                        ["User ID", data.UserID],
                        ["User Seed", data.UserSeed],
                        ["Time spent", data.Timespend],
                        ["Timestamp", format(new Date(data.Timestamp * 1000), "dd.MM.yyyy HH:mm:ss")],
                        ["Save ID", data.SaveID],
                        ["Install version", data.InstallVersion],
                        ["Current version", data.CurrentVersion],
                        ["FB profile", data.Records.FacebookProfile?.Connected?.toString()]
                    ],
                    payment_info: [

                        ["Total payments", data.Records?.PaymentProfile?.PaymentSUM],
                        ["Segment", paymentUserStatus(data.Records?.PaymentProfile?.PaymentSUM)],
                        ["Payment Count", data.Records?.PaymentProfile?.PaymentCNT],
                        ["Payment Date", data.Records?.PaymentProfile?.PaymentDate===undefined ? 'no data':format(new Date(data.Records.PaymentProfile.PaymentDate * 1000), "dd.MM.yyyy HH:mm:ss")],
                        ["Payment Min", data.Records?.PaymentProfile?.PaymentLST],
                        ["Payment Max", data.Records?.PaymentProfile?.PaymentMAX],

                    ],
                    progress_info: [
                        ["LevelActiveID", data.Records.ProgressionProfile.LevelActiveID],
                        ["Total levels", data.Records.ProgressionProfile.TotalLevels]
                    ],
                    ingame_goods: [],

//format(new Date(item.Timestamp * 1000), "dd.MM.yyyy HH:mm:ss")
                }
                if(battlePass != undefined) {
                    source.lc_profile = [
                        ["Battle Pass", battlePass?.Records[0].ID],
                        ["Activated", format(new Date(battlePass?.Records[0]?.ActivatedTimestamp * 1000), "dd.MM.yyyy HH:mm:ss")],
                        ["Completed", battlePass?.Records[0]?.CompletedTimestamp===0?'0 (not completed)':format(new Date(battlePass?.Records[0]?.CompletedTimestamp * 1000), "dd.MM.yyyy HH:mm:ss")],
                        ["Till", format(new Date(battlePass?.Records[0]?.TillTimestamp * 1000), "dd.MM.yyyy HH:mm:ss")]
                    ]
                } else {
                    source.lc_profile = []
                }
            } catch (e) {
                console.log(e)
                return <Alert severity={"error"}>Can't parse state</Alert>
            }


            panel1 = <Grid container spacing={2}>
                <Grid size={4}>
                    <Card>
                        <CardContent>
                            <Typography sx={{fontSize: 16}}>
                                Account Info
                            </Typography>
                        </CardContent>

                        <SimpleTable data={source.account_info}/>
                        <Stack direction="column" sx={{ p: 2, rowGap: 1 }}>
                            <SpammerControl userId={deviceId} project="mc" />
                        </Stack>
                    </Card>

                </Grid>


                <Grid size={4}>
                    <Stack direction="column" spacing={2}>
                        <Card>
                            <CardContent>
                                <Typography sx={{fontSize: 16}}>
                                    Progress Info
                                </Typography>
                            </CardContent>
                            <SimpleTable data={source.progress_info}/>
                        </Card>
                        <Card>
                            <CardContent>
                                <Typography sx={{fontSize: 16}}>
                                    LC Profile
                                </Typography>
                            </CardContent>
                            <SimpleTable data={source.lc_profile}/>
                        </Card>
                    </Stack>
                </Grid>

                <Grid size={4}>
                    <TechInfoMC isSimple={true} deviceId={deviceId}/>
                </Grid>

                <Grid size={4}>
                    <Card>
                        <CardContent>
                            <Typography sx={{fontSize: 16}}>
                                Payment Info
                            </Typography>
                        </CardContent>
                        <SimpleTable data={source.payment_info}/>
                    </Card>
                </Grid>

                <Grid size={4}>
                    <UserSocialInfoMC deviceId={deviceId}/>
                </Grid>

                <Grid size={12}>
                    <StateCopyLogCard logs={obj?.copyLogs}/>
                </Grid>
            </Grid>

        }



    } else if (typeof obj === "object" && obj.data.hasOwnProperty('error')) {
        panel1 = obj.data.error
    } else {
        panel1 = 'unknown error'
    }

    return (
       <>
           <Loading
               isLoading={isLoading||isFetching}
               isError={isError}
               error={error}
           >
               {panel1}
           </Loading>
       </>
    );

}

export default DashboardMC
